import React from 'react'
import { connect } from 'react-redux'
import Link from '../../fm/lib/Link'

class Breadcrumb extends React.Component {
	state = {
		location: null
	}
	findRecursive = (menu, searchLocation) => {
		const {p, title, items} = menu
		if (p === searchLocation) {
			return [{p, title}]
		}
		if (!items) return null
		
		const section = [{p, title}]
		for (let i in items) {
			let subsection = this.findRecursive(items[i], searchLocation)
			if (subsection) return section.concat(subsection)
		}
		return null
	}
	
	findSections = () => {
		const {menu, location} = this.props
		if (!menu || !location) return null
		
		const toks = location.split('/')
		toks.pop()
		const searchLocation = toks.join('/')
		
		let sections = null
		for(let i in menu.items) {
			sections = this.findRecursive(menu.items[i], searchLocation)
			if(sections) return sections
		}
		return null
	}
	render() {
		const sections = this.findSections()
		if (!sections) return null

		return (
			<div className='breadcrumb'>
				{sections.map((section, i) => <Link key={i} to={section.p}>{section.title}</Link>)}
			</div>
		)
	}
}
function mapStateToProps(state) {
	return {
		menu: (state.page.menu && state.page.menu.data)?state.page['menu'].data[0]:null,
		location: state.page.location
	}
}

export default connect(mapStateToProps)(Breadcrumb);




// WEBPACK FOOTER //
// ./src/components/extensions/Breadcrumb.js